import {Products} from "@/app/enums/Products"

export type ThemeCocoon =
    | Products.LOAN_INSURANCE
    | Products.LOAN
    | Products.HEALTH
    | Products.DEATH_INSURANCE
    | Products.INSURANCES
    | Products.TRAVEL

export interface IThemeColors {
    primary: string
    secondary1: string
    secondary2: string
    primaryText: string
    secondaryText: string
}

export interface ITheme {
    cocoons: ThemeCocoon[]
    colors: IThemeColors
}

const THEMES: ITheme[] = [
    {
        cocoons: [Products.LOAN_INSURANCE],
        colors: {
            primary: "pastel-yellow",
            secondary1: "deep-green",
            secondary2: "pastel-pink",
            primaryText: "black",
            secondaryText: "white",
        },
    },
    {
        cocoons: [Products.LOAN],
        colors: {
            primary: "pastel-pink",
            secondary1: "deep-green",
            secondary2: "pastel-yellow",
            primaryText: "black",
            secondaryText: "white",
        },
    },
    {
        cocoons: [Products.HEALTH, Products.DEATH_INSURANCE],
        colors: {
            primary: "pastel-orange",
            secondary1: "pastel-pink",
            secondary2: "pastel-yellow",
            primaryText: "black",
            secondaryText: "black",
        },
    },
    {
        cocoons: [Products.TRAVEL],
        colors: {
            primary: "pastel-blue",
            secondary1: "pastel-orange",
            secondary2: "pastel-yellow",
            primaryText: "black",
            secondaryText: "black",
        },
    },
    {
        cocoons: [Products.INSURANCES],
        colors: {
            primary: "pastel-blue",
            secondary1: "pastel-orange",
            secondary2: "pastel-yellow",
            primaryText: "black",
            secondaryText: "white",
        },
    },
]

const DEFAULT_COLORS: IThemeColors = {
    primary: "pastel-blue",
    secondary1: "pastel-orange",
    secondary2: "pastel-yellow",
    primaryText: "black",
    secondaryText: "black",
}

export function toVariant(color: string, variant: "pastel" | "deep"): string {
    return color.replace(/^(pastel|deep)-/, `${variant}-`)
}

export function getThemeColors(cocoon?: ThemeCocoon | string): IThemeColors {
    if (!cocoon) return DEFAULT_COLORS
    const match = THEMES.find((t) => t.cocoons.includes(cocoon as ThemeCocoon))
    return match?.colors ?? DEFAULT_COLORS
}
